var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"commissions-stats-component",attrs:{"id":"commissions_stats_component"}},_vm._l((_vm.stats),function(stat,index){return _c('b-col',{key:index,attrs:{"lg":"3","cols":"6"}},[_c('stats-item',{attrs:{"label":stat.label,"value":stat.value}})],1)}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-037e511c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/partials/section/content/commissions/CommissionsStats.vue
// module id = Kmko
// module chunks = 0